import React, { useState, useEffect, useCallback } from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MenuIcon from '@material-ui/icons/Menu';

import { Accordion } from '@material-ui/core';
import { AccordionSummary } from '@material-ui/core';
import { AccordionDetails } from '@material-ui/core';
import Search from '@material-ui/icons/Search';

import {
    makeStyles,
    Typography,
    FormControlLabel,
    Checkbox,
    Divider,
    Button,
    Toolbar,
    AppBar,
    IconButton,
    withStyles,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    ListItemSecondaryAction,
    Box,
    CircularProgress,
    Grid,
    FormControl,
    InputLabel,
    FilledInput,
    InputAdornment,
} from '@material-ui/core';

import styles from './styles';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllServicesStatus, fetchServices } from 'app/store/slices/services';
import moment from 'moment';
import { fetchActiveInactiveUsers } from 'app/store/slices/user';
import helpers from 'app/utils/helpers';
import notification from 'app/config/notification';
import { injectIntl } from 'react-intl';
import { STATUS_COLORS } from 'app/config/status';
import { StringUtils } from '../../../../utils/StringUtils';

const useStyles = makeStyles(styles);

const ExpansionPanel = withStyles({
    root: {
        border: '0',
        boxShadow: 'none',
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    expanded: {},
})(Accordion);

const ExpansionPanelSummary = withStyles({
    root: {
        backgroundColor: 'rgba(0, 0, 0, .03)',
        borderBottom: 'none',
        marginBottom: -1,
        minHeight: 50,
        '&$expanded': {
            minHeight: 50,
        },
    },
    content: {
        '&$expanded': {
            margin: '0',
        },
    },
    expanded: {},
})(AccordionSummary);

const ExpansionPanelDetails = withStyles((theme) => ({
    root: {
        borderBottom: 'none',
        padding: theme.spacing(2),
    },
}))(AccordionDetails);

function FiltersMenu(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { filters, setFilters, loading } = props;

    const allStatus = useSelector((state) => state.services.allServicesStatus);
    const allServices = useSelector((state) => state.services.internalServices);
    const allUsers = useSelector((state) => state.auth.activeInactiveUsers);

    const [checkedStatus, setCheckedStatus] = useState([]);
    const [checkedTypes, setCheckedTypes] = useState([]);
    const [checkedUsers, setCheckedUsers] = useState([]);

    const allStatusChecked = allStatus.length > 0 && checkedStatus.length === allStatus.length;
    const allTypesChecked = allServices.length > 0 && checkedTypes.length === allServices.length;
    const allUsersChecked = allUsers.length > 0 && checkedUsers.length === allUsers.length;

    const [initialDate, setInitialDate] = useState(filters['dtPeriodoInicialCadastro'] ? filters['dtPeriodoInicialCadastro'] : null);
    const [searchText, setSearchText] = useState(filters.txtBusca || '');

    const [finalDate, setFinalDate] = useState(null);

    const [pendencyInitialDate, setPendencyInitialDate] = useState(null);
    const [pendencyFinalDate, setPendencyFinalDate] = useState(null);

    const [loadingFiltersStatus, setLoadingFiltersStatus] = useState(true);
    const [loadingFiltersTypes, setLoadingFiltersTypes] = useState(true);
    const [loadingFiltersUsers, setLoadingFiltersUsers] = useState(true);

    const handlePendecyDateInicialChange = (date) => {
        setPendencyInitialDate(date);
    };

    const handlePendencyDateFinalChange = (date) => {
        setPendencyFinalDate(date);
    };

    const handleDateInicialChange = (date) => {
        setInitialDate(date);
    };

    const handleDateFinalChange = (date) => {
        setFinalDate(date);
    };

    const onChangeTxtBusca = (event) => {
        setSearchText(event.target.value);
    };

    const onBlurTxtBusca = () => {
        setSearchText(prev => prev !== null ? prev.trim() : '');
    };

    useEffect(() => {
        (async () => {
            try {
                if (allStatus.length === 0) {
                    setLoadingFiltersStatus(true);
                    await dispatch(fetchAllServicesStatus());
                }
            } catch (error) {}
            setLoadingFiltersStatus(false);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    useEffect(() => {
        (async () => {
            try {
                setLoadingFiltersTypes(true);
                await dispatch(fetchServices(null, true));
            } catch (error) {}
            setLoadingFiltersTypes(false);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    useEffect(() => {
        (async () => {
            try {
                if (allUsers.length === 0) {
                    setLoadingFiltersUsers(true);
                    await dispatch(fetchActiveInactiveUsers());
                }
            } catch (error) {}
            setLoadingFiltersUsers(false);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    useEffect(() => {
        checkAll('status', null);
        checkAll('types', null);
        checkAll('users', null);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [allStatus, allServices, allUsers]);


    useEffect(() => {
        if (allStatus.length && allServices.length && allUsers.length) {
            setCheckedStatus(filters.situacoes || []);
            setCheckedTypes(filters.servicos || allServices);
            setCheckedUsers(filters.usuarios || []);
            setInitialDate(filters.dtPeriodoInicialCadastro || null);
            setFinalDate(filters.dtPeriodoFinalCadastro || null);
            setPendencyInitialDate(filters.dtPeriodoInicialPendencias || null);
            setPendencyFinalDate(filters.dtPeriodoFinalPendencias || null);
            setSearchText(filters.txtBusca || '');
        }
    }, [filters, allStatus, allServices, allUsers]);


    const handleToggleCheckbox = (type, value) => () => {
        let bundle = checkedStatus;
        let functionSet = setCheckedStatus;
        let key = 'cdSituacao';

        if (type === 'types') {
            bundle = checkedTypes;
            functionSet = setCheckedTypes;
            key = 'cdServico';
        } else if (type === 'users') {
            bundle = checkedUsers;
            functionSet = setCheckedUsers;
            key = 'cdUsuario';
        }

        const currentIndex = bundle.findIndex(item => item[key] === value[key]);

        const newChecked = [...bundle];
        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }
        functionSet(newChecked);
    };

    const checkAll = useCallback((type, event) => {
        let allItems = [];
        let setChecked;

        switch (type) {
            case 'status':
                allItems = allStatus;
                setChecked = setCheckedStatus;
                break;
            case 'types':
                allItems = allServices;
                setChecked = setCheckedTypes;
                break;
            case 'users':
                allItems = allUsers;
                setChecked = setCheckedUsers;
                break;
            default:
                return;
        }

        const isChecking = event?.target?.checked;

        let newChecked = isChecking ? [...allItems] : [];

        setChecked(newChecked);
    }, [ allStatus, allServices, allUsers ]);

    const handleApplyFilter = () => {
        const temp = { ...filters };
        let pendencyDateError = false;
        let dateError = false;
        if (pendencyInitialDate) {
            temp['dtPeriodoInicialPendencias'] = moment.utc(pendencyInitialDate).format('YYYY-MM-DD');
            if (!helpers.validateDate(temp['dtPeriodoInicialPendencias'])) {
                pendencyDateError = true;
            }
        } else {
            delete temp['dtPeriodoInicialPendencias'];
        }
        if (pendencyFinalDate) {
            temp['dtPeriodoFinalPendencias'] = moment.utc(pendencyFinalDate).format('YYYY-MM-DD');
            if (!helpers.validateDate(temp['dtPeriodoFinalPendencias'])) {
                pendencyDateError = true;
            }
        } else {
            delete temp['dtPeriodoFinalPendencias'];
        }
        if (
            StringUtils.notIsBlank(temp['dtPeriodoInicialPendencias']) &&
            StringUtils.notIsBlank(temp['dtPeriodoFinalPendencias'])
        ) {
            let isAfter = moment
                .utc(temp['dtPeriodoFinalPendencias'])
                .isSameOrAfter(temp['dtPeriodoInicialPendencias']);
            if (!isAfter) {
                pendencyDateError = true;
            }
        }

        if (initialDate) {
            temp['dtPeriodoInicialCadastro'] = moment.utc(initialDate).format('YYYY-MM-DD');
            if (!helpers.validateDate(temp['dtPeriodoInicialCadastro'])) {
                pendencyDateError = true;
            }
        } else {
            delete temp['dtPeriodoInicialCadastro'];
        }
        if (finalDate) {
            temp['dtPeriodoFinalCadastro'] = moment.utc(finalDate).format('YYYY-MM-DD');
            if (!helpers.validateDate(temp['dtPeriodoFinalCadastro'])) {
                pendencyDateError = true;
            }
        } else {
            delete temp['dtPeriodoFinalCadastro'];
        }
        if (
            StringUtils.notIsBlank(temp['dtPeriodoInicialCadastro']) &&
            StringUtils.notIsBlank(temp['dtPeriodoFinalCadastro'])
        ) {
            let dateFinalUTC = moment.utc(temp['dtPeriodoFinalCadastro']);
            let dateInicialUTC = moment.utc(temp['dtPeriodoInicialCadastro']);
            let isSameOrAfter = dateFinalUTC.isSameOrAfter(dateInicialUTC);
            if (!isSameOrAfter) {
                pendencyDateError = true;
            }
        }

        if (pendencyDateError || dateError) {
            notification(
                'Favor verificar datas informadas. Elas precisam ser válidas e a data final maior ou igual a data incial.',
                {
                    toastId: 'DATE_PROBLEM',
                    type: 'error',
                },
            );
            return;
        }

        temp.situacoes = checkedStatus;
        temp.servicos = checkedTypes;
        temp.usuarios = checkedUsers.filter(usuario => Object.keys(usuario).length > 0);
        temp.txtBusca = searchText;

        temp.page = 0;
        setFilters(temp);
    };



    return (
        <>
            <AppBar elevation={0} color="transparent" position="static" className={classes.topoFiltros}>
                <Toolbar variant="dense">
                    <IconButton disabled edge="start" color="inherit" aria-label="menu">
                        <MenuIcon color="primary" />
                    </IconButton>
                    <Typography variant="h6" className={classes.title}>
                        Filtros
                    </Typography>
                </Toolbar>
            </AppBar>
            <Box className={classes.boxFiltros}>
                <Box className={classes.boxIntFiltros}>
                    <FormControl size="small" className={classes.search} variant="filled">
                        <InputLabel>Busca</InputLabel>
                        <FilledInput
                            id="outlined-adornment-weight"
                            value={searchText}
                            onChange={onChangeTxtBusca}
                            onBlur={() => onBlurTxtBusca()}
                            endAdornment={
                                <InputAdornment position="end" style={{ opacity: 0.3 }}>
                                    <Search />
                                </InputAdornment>
                            }
                            aria-describedby="outlined-weight-helper-text"
                            inputProps={{
                                'aria-label': 'weight',
                            }}
                        />
                    </FormControl>
                </Box>
                <Box className={classes.boxIntFiltros}>
                    <div>Data da solicitação</div>
                    <Grid container spacing={0}>
                        <Grid item xs={12} sm={6}>
                            <KeyboardDatePicker
                                format="DD/MM/YYYY"
                                margin="dense"
                                label="Data inicial"
                                autoOk
                                clearable
                                invalidLabel="Data inválida"
                                invalidDateMessage="Data inválida"
                                maxDateMessage="Data inválida"
                                minDateMessage="Data inválida"
                                clearLabel={'Limpar'}
                                value={initialDate}
                                onChange={handleDateInicialChange}
                                KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <KeyboardDatePicker
                                format="DD/MM/YYYY"
                                margin="dense"
                                label="Data final"
                                autoOk
                                clearable
                                invalidLabel="Data inválida"
                                invalidDateMessage="Data inválida"
                                maxDateMessage="Data inválida"
                                minDateMessage="Data inválida"
                                clearLabel={'Limpar'}
                                value={finalDate}
                                onChange={handleDateFinalChange}
                                KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                }}
                            />
                        </Grid>
                    </Grid>
                </Box>
                <Box className={classes.boxIntFiltros}>
                    <div>Período vencimento pendências</div>
                    <Grid container spacing={0}>
                        <Grid item xs={12} sm={6}>
                            <KeyboardDatePicker
                                format="DD/MM/YYYY"
                                margin="dense"
                                label="Data inicial"
                                autoOk
                                clearable
                                invalidLabel="Data inválida"
                                invalidDateMessage="Data inválida"
                                maxDateMessage="Data inválida"
                                minDateMessage="Data inválida"
                                clearLabel={'Limpar'}
                                value={pendencyInitialDate}
                                onChange={handlePendecyDateInicialChange}
                                KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <KeyboardDatePicker
                                format="DD/MM/YYYY"
                                margin="dense"
                                label="Data final"
                                autoOk
                                clearable
                                invalidLabel="Data inválida"
                                invalidDateMessage="Data inválida"
                                maxDateMessage="Data inválida"
                                minDateMessage="Data inválida"
                                clearLabel={'Limpar'}
                                value={pendencyFinalDate}
                                onChange={handlePendencyDateFinalChange}
                                KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                }}
                            />
                        </Grid>
                    </Grid>
                </Box>
                <ExpansionPanel elevation={0} square defaultExpanded={false} className={classes.expansionPanel}>
                    <ExpansionPanelSummary className={classes.expansionPanelSummary} expandIcon={<ExpandMoreIcon />}>
                        <FormControlLabel
                            className={classes.filterLabel}
                            onClick={(event) => {
                                event.stopPropagation();
                            }}
                            onFocus={(event) => event.stopPropagation()}
                            control={
                                <Checkbox
                                    checked={allStatusChecked}
                                    onChange={(e) => checkAll('status', e)}
                            />}
                            label="Situação"
                        />
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                        {loadingFiltersStatus && (
                            <div className={classes.centerProgress}>
                                <CircularProgress size={20} />
                            </div>
                        )}
                        {!loadingFiltersStatus && (
                            <List dense={true} className={classes.lista}>
                                {allStatus &&
                                    allStatus.length > 0 &&
                                    allStatus.map((status) => {
                                        const labelId = `status-${status.cdSituacao}`;
                                        return (
                                            <div key={labelId}>
                                                <ListItem
                                                    key={labelId}
                                                    role={undefined}
                                                    dense
                                                    button
                                                    onClick={handleToggleCheckbox('status', status)}
                                                    className={classes.containerItemList}>
                                                    <ListItemIcon className={classes.listItemIcon}>
                                                        <Checkbox
                                                            edge="start"
                                                            checked={checkedStatus.some(s => s.cdSituacao === status.cdSituacao)}
                                                            tabIndex={-1}
                                                            disableRipple
                                                            inputProps={{ 'aria-labelledby': labelId }}
                                                        />
                                                    </ListItemIcon>
                                                    <ListItemText
                                                        id={labelId}
                                                        primary={status.deSituacao}
                                                        className={classes.titleList}
                                                    />
                                                    <ListItemSecondaryAction
                                                        className={classes.listItemSecondaryAction}>
                                                        <IconButton edge="end" aria-label="comments">
                                                            <div
                                                                className={classes.circle}
                                                                style={{
                                                                    backgroundColor: `${STATUS_COLORS[status.cdSituacao]?.color}`,
                                                                }}
                                                            />
                                                        </IconButton>
                                                    </ListItemSecondaryAction>
                                                </ListItem>
                                                <Divider />
                                            </div>
                                        );
                                    })}
                            </List>
                        )}
                    </ExpansionPanelDetails>
                </ExpansionPanel>
                {loadingFiltersStatus && (
                    <div className={classes.centerProgress}>
                        <CircularProgress size={20} />
                    </div>
                )}
                <ExpansionPanel elevation={0} square defaultExpanded={false} className={classes.expansionPanel}>
                    <ExpansionPanelSummary className={classes.expansionPanelSummary} expandIcon={<ExpandMoreIcon />}>
                        <FormControlLabel
                            className={classes.filterLabel}
                            onClick={(event) => {
                                event.stopPropagation();
                            }}
                            onFocus={(event) => event.stopPropagation()}
                            control={
                                <Checkbox
                                    checked={allTypesChecked}
                                    onChange={(e) => checkAll('types', e)}
                                />
                        }
                            label="Tipo de solicitação"
                        />
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                        {loadingFiltersTypes && (
                            <div className={classes.centerProgress}>
                                <CircularProgress size={20} />
                            </div>
                        )}
                        {!loadingFiltersTypes && (
                            <List dense={true} className={classes.lista}>
                                {allServices &&
                                    allServices.length > 0 &&
                                    allServices.map((service) => {
                                        const labelId = `service-${service.cdServico}`;
                                        return (
                                            <div key={labelId}>
                                                <ListItem
                                                    key={labelId}
                                                    role={undefined}
                                                    dense
                                                    button
                                                    onClick={handleToggleCheckbox('types', service)}
                                                    className={classes.containerItemList}>
                                                    <ListItemIcon className={classes.listItemIcon}>
                                                        <Checkbox
                                                            edge="start"
                                                            checked={checkedTypes.some(s => s.cdServico === service.cdServico)}
                                                            tabIndex={-1}
                                                            disableRipple
                                                            inputProps={{ 'aria-labelledby': labelId }}
                                                        />
                                                    </ListItemIcon>
                                                    <ListItemText
                                                        id={labelId}
                                                        primary={service.nmServico}
                                                        className={classes.titleList}
                                                    />
                                                </ListItem>
                                                <Divider />
                                            </div>
                                        );
                                    })}
                            </List>
                        )}
                    </ExpansionPanelDetails>
                </ExpansionPanel>
                {loadingFiltersTypes && (
                    <div className={classes.centerProgress}>
                        <CircularProgress size={20} />
                    </div>
                )}
                <ExpansionPanel elevation={0} square defaultExpanded={false} className={classes.expansionPanel}>
                    <ExpansionPanelSummary className={classes.expansionPanelSummary} expandIcon={<ExpandMoreIcon />}>
                        <FormControlLabel
                            className={classes.filterLabel}
                            onClick={(event) => event.stopPropagation()}
                            onFocus={(event) => event.stopPropagation()}
                            control={
                                <Checkbox
                                    checked={allUsersChecked}
                                    onChange={(e) => checkAll('users', e)}
                                />
                            }
                            label="Usuários"
                        />
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                        {!loadingFiltersUsers && (
                            <List dense={true} className={classes.lista}>
                                {allUsers &&
                                    allUsers.length > 0 &&
                                    allUsers.map((user) => {
                                        const labelId = `user-${user.cdUsuario}`;
                                        return (
                                            <div key={labelId}>
                                                <ListItem
                                                    key={labelId}
                                                    role={undefined}
                                                    dense
                                                    button
                                                    onClick={handleToggleCheckbox('users', user)}
                                                    className={classes.containerItemList}>
                                                    <ListItemIcon className={classes.listItemIcon}>
                                                        <Checkbox
                                                            edge="start"
                                                            checked={checkedUsers.some(u => u.cdUsuario === user.cdUsuario)}
                                                            tabIndex={-1}
                                                            disableRipple
                                                            inputProps={{ 'aria-labelledby': labelId }}
                                                        />
                                                    </ListItemIcon>
                                                    <ListItemText
                                                        id={labelId}
                                                        primary={user.nmUsuario}
                                                        className={classes.titleList}
                                                    />
                                                </ListItem>
                                                <Divider />
                                            </div>
                                        );
                                    })}
                            </List>
                        )}
                    </ExpansionPanelDetails>
                </ExpansionPanel>
                {loadingFiltersUsers && (
                    <div className={classes.centerProgress}>
                        <CircularProgress size={20} />
                    </div>
                )}
            </Box>
            <Box className={classes.boxBtnFiltrar}>
                <Button
                    className={!loading ? classes.btnFiltrar : classes.btnFiltrarDisabled}
                    onClick={() => handleApplyFilter()}
                    variant="contained"
                    color="primary"
                    disableElevation
                    disabled={loading}>
                    Filtrar
                </Button>
            </Box>
        </>
    );
}

export default injectIntl(FiltersMenu);
